import { render, staticRenderFns } from "./referral-agreement.vue?vue&type=template&id=759bee46&scoped=true&lang=pug&"
var script = {}
import style0 from "./referral-agreement.vue?vue&type=style&index=0&id=759bee46&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759bee46",
  null
  
)

export default component.exports